import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { SnotifyService } from 'ng-snotify';

import { CoreService } from 'src/app/core/core.service';
import { Constants } from 'src/app/shared/constants.service';
import { AssembleClassInfo } from 'src/app/interfaces/assemble-class-info';
import { SeoService } from 'src/app/services/seo.service';

@Component({
  selector: 'cm-assemble-class',
  templateUrl: './assemble-class.component.html',
  styleUrls: ['./assemble-class.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AssembleClassComponent implements OnInit {
  assembleClassInfo: AssembleClassInfo = new AssembleClassInfo;
  form: FormGroup;
  states: any;
  jobs: any;
  citiesNames: any;
  coursesNames: any;
  banner: string = '';
  private _courses;
  private _selectedCourseId;
  private _cities;
  private _selectedCityId;
  private _selectedUfId;

  constructor(
    private _formBuilder: FormBuilder,
    private _snotifyService: SnotifyService,
    private _activatedRoute: ActivatedRoute,
    private _seoService: SeoService,
    private _coreService: CoreService) { }

  ngOnInit() {
    this._activatedRoute.url.subscribe((url: any) => {
      let path = '';
      url.map(item => path += '/' + item.path);
      path = path.substring(1);
      this._seoService.defineTags(path);
    });

    //this._getBanner();
    this._getAssembleClassInfo();

    this.form = this._formBuilder.group({
      name: [null, [Validators.required]],
      email: [null, [Validators.required, Validators.email]],
      phone: [null, [Validators.required]],
      job_id:[null, [Validators.required]],
      uf_id: [null, [Validators.required]],
      city_id: [null, [Validators.required]],
      course_id: [null, [Validators.required]],
      token: [null, [Validators.required]]
    });

    this.states = Constants.states;
    this.jobs = Constants.jobs;
  }

  // ----- PUBLIC METHODS
  captchaResponse(event): void {
    this.form.patchValue({token: event.response});
  }

  captchaExpires(): void {
    this.form.patchValue({token: null});
  }

  searchCity(event: any): void {
    let params = {'search_text': event.query};
    this._coreService.getCities(params).subscribe(response => {
      this._cities = response;
      this.citiesNames = response.map(city => city.name + ` - `+ city.uf);
    })
  }

  defineCity(cityName: any): void {
    this._cities.find(city => {
      if(city.name + ` - `+ city.uf === cityName){
        this._selectedCityId = city.id;
        this._selectedUfId = city.uf_id;
        return true;
      }
    })
  }

  searchCourse(event: any): void {
    let params = {'search_text': event.query};
    this._coreService.getCourseTypes(params).subscribe((response: any) => {
      this._courses = response;
      this.coursesNames = response.map(course => course.name);
    })
  }

  defineCourse(courseName: any): void {
    this._courses.find(course => {
      if(course.name === courseName){
        this._selectedCourseId = course.id;
        return true;
      }
    })
  }

  save(): void {
    let params = this.form.getRawValue();
    params['phone'] = this.form.get('phone').value.replace(/\D/g,''),
    params['city_id'] = this._selectedCityId;
    params['uf_id'] = this._selectedUfId;
    params['course_id'] = this._selectedCourseId;

    this._coreService.saveAssembleClass(params).subscribe(() => {
      this.form.reset();
      this._selectedCityId = null;
      this._selectedUfId = null;
      this._selectedCourseId = null;

      this._snotifyService.success('Dados enviados com sucesso.', '', {
        timeout: 3000,
        showProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        position: 'centerTop'
      })
    }, () => {
      this._snotifyService.success('Algum erro ocorreu, tente novamente em instantes', '', {
        timeout: 3000,
        showProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        position: 'centerTop'
      })
    })
  }

  // ----- PRIVATE METHODS
  private _getAssembleClassInfo(): void {
    this._coreService.getAssembleClassInfo().subscribe((response: any) => {
      this.assembleClassInfo = response;
      this.banner = response.banner;
    })
  }

  private _getBanner(): void {
    const params = {page: 'monte-sua-turma'};
    this._coreService.getPageBanner(params).subscribe((response: any) => {
      this.banner = response.image_url;
    })
  }
}
